import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Navbar = () => {
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="bg-white border-b-2 border-milo-beige-dark sticky top-0 z-40 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center">
            <h1 className="text-3xl font-serif text-milo-black hover:text-milo-gold transition-colors duration-200">
              MILO
            </h1>
          </Link>

          <div className="flex items-center space-x-8">
            <Link
              to="/"
              className="text-milo-gray hover:text-milo-black font-medium transition-colors duration-200"
            >
              Inicio
            </Link>

            {isAuthenticated && user?.role === 'admin' ? (
              <>
                <Link
                  to="/admin"
                  className="text-milo-gray hover:text-milo-black font-medium transition-colors duration-200"
                >
                  Panel Admin
                </Link>
                <button
                  onClick={handleLogout}
                  className="text-milo-gray hover:text-milo-black font-medium transition-colors duration-200"
                >
                  Cerrar Sesión
                </button>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
